import {LegacyRegulationWrapper} from "../legacy-regulation-wrapper";
import {
    NewJerseyExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/regulations/new-jersey/new-jersey.external-links-handlers-factory";
import {
    IExternalLinksHandlersFactory
} from "../../external-links/handlers-factory/external-links-handlers-factory.interface";
import {IRegulationComponents} from "../regulation-components.interface";
import {NewJerseyRegulationComponents} from "./components/new-jersey.regulation-components";
import {DialogButtonClickHandleResultEnum} from "../../dialog/dialog.service.interface";
import {NullableString} from "../../../../common/types/nullable-types";

export class NewJerseyRegulation extends LegacyRegulationWrapper {
    get externalLinks(): IExternalLinksHandlersFactory {
        return new NewJerseyExternalLinksHandlersFactory(this.services);
    }

    get components(): IRegulationComponents {
        return new NewJerseyRegulationComponents(this.services);
    }
    async logoutUser(): Promise<void>{
        await super.logoutUser();
        this.services.dialog.showSimpleTextModal({
            title: this.services.translation.translate('NJ_LOGOUT_MESSAGE_TITLE'),
            text: this.services.translation.translate('NJ_LOGOUT_MESSAGE_TEXT'),
            shouldBeClosedOnlyByUser: true,
            buttons: [
                {
                    text: this.services.translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async ()=> {
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue;
                    }
                }
            ]
        })
    }

    formatLastLoginFromUnixTimeStampInSeconds(lastLoginUnixTimeStampInSeconds: number): NullableString {
        const date = new Date(lastLoginUnixTimeStampInSeconds * 1000);

        const options: Intl.DateTimeFormatOptions = {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };

        return new Intl.DateTimeFormat('en-US', options).format(date);

    }
}